import axios from 'axios';
import { baseUrl } from './ApiConfig';

const CONTROLLER_NAME = "ContactForm";

export const postContactFormAsync = async (data) => {
    const response = await axios.post(`${baseUrl()}${CONTROLLER_NAME}/PostForm`, data);
    return response.data;
}